import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseComponent } from '../../base/base-component.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'field-validation',
  templateUrl: './field-validation.component.html',
  styleUrls: ['./field-validation.component.css']
})
export class FieldValidation extends BaseComponent implements OnInit {

  @Input() control: FormControl;
  @Input() name: string;

  constructor(translateService: TranslateService) {
    super(translateService);
    this.setTranslateContext('FieldValidation');
  }

  ngOnInit() {
  }
}
